function mapGatewayName(type) {
  let result = "";
  switch (type) {
    case "Mellat":
      result = "ملت";
      break;
    case "Pasargod":
      result = "پاسارگاد";
      break;
    case "ZarinPal":
      result = "زرین پال";
      break;    
    default:
      result = "";
      break;
  }
  return result;
}
export default mapGatewayName;
